import React from "react";
import {flexRender} from "@tanstack/react-table";

const MapColumn = (header) => {
    if (header.isPlaceholder) {
        return null;
    }
    return <>
        <div
            {...{
                className: header.column.getCanSort() ? 'cursor-pointer select-none'
                    : '',
                onClick: header.column.getToggleSortingHandler(),
            }}>
            {flexRender(
                header.column.columnDef.header,
                header.getContext()
            )}
            <span>
                  {{
                      asc: ' 🔼',
                      desc: ' 🔽',
                  }[header.column.getIsSorted()] ?? null}
                </span>
        </div>
    </>
}
export const TableHead = ({headerGroups}) => {

    return (<thead className="thead-dark">
        {headerGroups.map(headerGroup => (
            <tr key={headerGroup.id}>
                {headerGroup.headers.map(header => {
                    return <th key={header.id} colSpan={header.colSpan} style={{minWidth: header.column.columnDef.minWidth, width: header.column.columnDef.width}}>
                        {MapColumn(header)}
                    </th>
                })}
            </tr>
        ))}
        </thead>
    )
}

